import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubmitEntityData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { createBaseResource, JoiResource } from 'globals/store/resources.data';
import { BrandingData } from 'globals/store/publish.data';
import { CommonModule } from '@angular/common';
import { ShareResourceFormComponent } from './share-resource-form.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';

@Component({
    selector: 'share-submit-resource',
    template: `
<branding-wrapper
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !resource" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your profile information has been submitted.
  </div>
  <share-edit-resource-form *ngIf="!!brandingData && !!resource && !submitted"
    [topTitle]="(templateTitle || 'Call to Submit Resources') + ': ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [resource]="resource"
    [publishCode]="templateId"
    [instructions]="instructions"
    [customQuestions]="customQuestions"
    [error]="error"
    [processing]="processing"
    [template]="brandingData.template"
    [callToSubmit]="true"
    (onSubmit)="submit()">
  </share-edit-resource-form>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [CommonModule, ShareResourceFormComponent, BrandingWrapperComponent],
})
export class ResourceSubmitComponent extends ShareWrapper<ResourceSubmitComponent> {
  templateId: string
  submitted: boolean
  eventId: string
  eventName: string
  templateTitle: string
  cannotSubmitMessage = "A new resource profile can't be submitted at this time."
  resource: JoiResource
  inactiveUrlMessage = "This call for new resources is not currently available."
  customQuestions: CustomQuestion[] = []
  instructions: string
  brandingData: BrandingData

  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";

    this.route.params.subscribe(params=>{
      const { eventId, templateId } = params;
      if (!eventId || !templateId) {
        this.loading = false;
        document.title = "Unavailable";
        return
      }
      this.templateId = templateId
      this.eventId = eventId
      const queryData: SubmitEntityData = { entityType: 'resource', submitTemplateId: templateId, eventId }
      this.publicService.loadSubmitEntityExtraData(queryData).then(data => {
        if (!data) {
          this.cannotLoad()
          return
        }
        const { eventTitle, customQuestions, templateTitle, instructions, brandingData } = data
        this.instructions = instructions
        this.loading = false
        this.resource = createBaseResource(() => null)
        this.eventName = eventTitle
        this.customQuestions = customQuestions
        this.templateTitle = templateTitle
        this.brandingData = brandingData
        document.title = `Call for new resources`;
      }).catch(this.cannotLoad.bind(this))          
    })
  }



  cannotLoad(errorResponse = '') {
    if (errorResponse) console.error(errorResponse)
    this.loading = false
    this.showError(this.inactiveUrlMessage)
  }


  async submit() {
    const { templateId, eventId, resource } = this
    const submitData: SubmitEntityData = { entityType: 'resource', submitTemplateId: templateId, eventId, entity: resource }
    await this.submitEntity(submitData, this.cannotSubmitMessage)
  }
}

